import * as React from 'react';

import styled, { css } from 'styled-components';

import { breakpoints, IBasicStyledProps } from '@notino/react-styleguide';

type Props = {
  children?: React.ReactNode;
  breakpoint: keyof typeof breakpoints;
} & IBasicStyledProps;

const HiddenWrapper = styled.div<Pick<Props, 'breakpoint'>>`
  ${({ breakpoint }) => css`
    @media (min-width: ${breakpoints[breakpoint]}) {
      display: none;
    }
  `}
`;

const VisibleWrapper = styled.div<Pick<Props, 'breakpoint'>>`
  display: none;

  ${({ breakpoint }) => css`
    @media (min-width: ${breakpoints[breakpoint]}) {
      display: block;
    }
  `}
`;

export const Hidden = ({ children, breakpoint, ...rest }: Props) => {
  return (
    <HiddenWrapper breakpoint={breakpoint} {...rest}>
      {children}
    </HiddenWrapper>
  );
};

export const Visible = ({ children, breakpoint, ...rest }: Props) => {
  return (
    <VisibleWrapper breakpoint={breakpoint} {...rest}>
      {children}
    </VisibleWrapper>
  );
};
